import type { Address } from "viem"
import type { Config } from "wagmi"

import type { TransactionReturnType } from "@/domains/on-chain/types"
import { increaseLockDuration as increaseLockDurationOnChain } from "@/domains/on-chain"

import type { IIncreaseLockDurationActions } from "./interfaces"

/**
 * Adapter that implements IIncreaseLockDurationActions using the actual on-chain functions.
 * This is the production implementation injected into the interaction.
 */
export class IncreaseLockDurationActionsAdapter implements IIncreaseLockDurationActions {
  async increaseLockDuration(params: {
    account: Address
    chainId: number
    config: Config
    vestedAddress: Address
    tokenId: number
    secondsToExtend: number
  }): Promise<TransactionReturnType> {
    return await increaseLockDurationOnChain(params)
  }
}
